import { WindowSize } from '@getaccept/lib-shared/src/enums/window-size';
import { isWindowSize } from '@getaccept/lib-shared/src/helpers/window-size.helper';
import type { AssemblerState } from './assembler.types';

export const getDefaultState: () => AssemblerState = () => ({
  loading: false,
  loaded: false,

  document: undefined,
  currentDocumentPage: undefined,
  pageToBeReplaced: null,

  selectedUser: null,
  selectedRecipient: { id: null, connectFirstRecipient: null },
  previewToken: {
    jwt: null,
    exp: null,
  },

  activeContentSelector: null,
  addRoleModalVisible: false,
  documentSettingsVisible: false,
  sidebarCollapsed: isWindowSize(WindowSize.Medium),

  updatingDimensions: false,
});
